<div class="container-titulo-receber-pagamento-table">
    <table class="table table-striped table-hover table-bordered" id="tableTituloReceberPagamento">
        <thead>
            <tr>
                <th class="col-sequencia text-center">Seq.</th>
                <th class="col-data text-center">Data</th>
                <th class="col-valor-juros text-right">Juros</th>
                <th class="col-valor-multa text-right">Multa</th>
                <th class="col-valor-acrescimo text-right">Acrescimo</th>
                <th class="col-valor-desconto text-right">Desconto</th>
                <th class="col-valor-pago text-right">Valor Pago</th>
                <th class="col-valor-adimplencia text-right">Valor Adimplencia</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let entity of entities">
                <td class="col-sequencia text-center">{{entity.sequencia}}</td>
                <td class="col-data text-center">{{entity.data | date:'dd/MM/yyyy'}}</td>
                <td class="col-valor-juros text-right">{{entity.valorJuros | decimalFormat: 1:2:2}}</td>
                <td class="col-valor-multa text-right">{{entity.valorMulta | decimalFormat: 1:2:2}}</td>
                <td class="col-valor-acrescimo text-right">{{entity.valorAcrescimo | decimalFormat: 1:2:2}}</td>
                <td class="col-valor-desconto text-right">{{entity.valorDesconto | decimalFormat: 1:2:2}}</td>
                <td class="col-valor-pago text-right">{{entity.valorPago | decimalFormat: 1:2:2}}</td>
                <td class="col-valor-adimplencia text-right">{{entity.valorAdimplencia | decimalFormat: 1:2:2}}</td>
            </tr>
        </tbody>
    </table>
</div>
